module.exports = {
  LOGIN: 'auth/customer-login',
  REGISTER: 'auth/register',
  LOGOUT: 'auth/logout',
  REFRESH: 'auth/refresh',
  SENDRESETLINK: "auth/sendresetlink",
  RESETPASSWORD: "auth/resetpassword",

  GETUSERSBYCOMPANY: 'user/getbycompany',
  GETUSERSBYBRANCH: 'user/getbybranch',
  CREATEUSER: 'user',
  UPDATEUSER: 'user',
  DELETEUSER: 'user',
  GETUSERPROFILE: 'user/getprofile',
  CHANGEPASSWORD: 'user/changepassword',

  GETALLCOMPANIES: 'company/getall',
  GETCOMPANIES: 'company/get',
  GETCOMPANYBYID: 'company/getbyid',
  GETCOMPANYBYUSER: 'company/getbyuser',
  GETCOMPANYAGENTS: 'company/agents',
  CREATECOMPANY: 'company',
  UPDATECOMPANY: 'company',
  DELETECOMPANY: 'company',

  GETALLBRANCHES: 'branch/getall',
  GETBRANCHES: 'branch/get',
  GETBRANCHBYID: 'branch/getbyid',
  GETBRANCHBYUSER: 'branch/getbyuser',
  GETBRANCHBYCOMPANY: 'branch/getbycompany',
  CREATEBRANCH: 'branch',
  UPDATEBRANCH: 'branch',
  DELETEBRANCH: 'branch',

  GETCURRENCYBYCOMPANY: 'currency/getbycompany',
  CREATECURRENCY: 'currency',
  UPDATECURRENCY: 'currency',
  DELETECURRENCY: 'currency',

  GETALLSUPPLIERS: 'supplier/getall',
  GETSUPPLIERS: 'supplier/get',
  GETSUPPLIERBYCOMPANY: 'supplier/getbycompany',
  CREATESUPPLIER: 'supplier',
  UPDATESUPPLIER: 'supplier',
  DELETESUPPLIER: 'supplier',

  GETALLLEADSTATUS: 'leadstatus/getall',
  GETLEADSTATUS: 'leadstatus/get',
  GETLEADSTATUSBYCOMPANY: 'leadstatus/getbycompany',
  GETLEADSTATUSBYID: 'leadstatus/getbyid',
  CREATELEADSTATUS: 'leadstatus',
  UPDATELEADSTATUS: 'leadstatus',
  DELETELEADSTATUS: 'leadstatus',
  GETLEADSFORCALENDAR: 'lead/getbycompanyforcalendar',

  GETALLLEAD: 'lead/getall',
  GETLEAD: 'lead/get',
  GETLEADBYCOMPANY: 'lead/getbycompany',
  GETLEADBYUSER: 'lead/getbyuser',
  GETLEADBYID: 'lead/getbyid',
  CREATELEAD: 'lead',
  UPDATELEAD: 'lead',
  DELETELEAD: 'lead',

  GETALLMEETING: 'meeting/getall',
  GETMEETING: 'meeting/get',
  GETMEETINGBYLEAD: 'meeting/getbylead',
  GETMEETINGBYID: 'meeting/getbyid',
  CREATEMEETING: 'meeting',
  UPDATEMEETING: 'meeting',
  DELETEMEETING: 'meeting',

  GETALLSOURCE: 'source/getall',
  GETSOURCE: 'source/get',
  GETSOURCEBYID: 'source/getbyid',
  CREATESOURCE: 'source',
  UPDATESOURCE: 'source',
  DELETESOURCE: 'source',

  GETPAYMENTGATEWAYBYCOMPANY: 'paymentgateway/getbycompany',
  CREATEPAYMENTGATEWAY: 'paymentgateway',
  UPDATEPAYMENTGATEWAY: 'paymentgateway',
  DELETEPAYMENTGATEWAY: 'paymentgateway',
  MAKEPAYMENT: 'payment/process',

  GETPROMOCODEBYCOMPANY: 'promocode/getbycompany',
  CREATEPROMOCODE: 'promocode',
  UPDATEPROMOCODE: 'promocode',
  DELETEPROMOCODE: 'promocode',

  SEARCHFLIGHTS: 'flight/search',
  REVIEWHFLIGHT: 'flight/review',
  FAREFLIGHT: 'flight/fare',
  // BOOKFLIGHT: 'flight/book',
  B2CBOOKFLIGHT: 'flight/B2Cbook',
  GETUSERFLIGHTBOOKINGS: 'flight/getbyuser',
  GETFLIGHTBOOKINGDETAILS: 'flight/getbyid',
  CONFIRMHOLDFLIGHTBOOKING: 'flight/Confirm-Hold',
  GETAIRPORTCODE:'home/airport/autocomplete',
  GETALLDESTINATIONTYPES: 'destinationtype/getall',
  GETDESTINATIONTYPES: 'destinationtype',
  CREATEDESTINATIONTYPE: 'destinationtype',
  UPDATEDESTINATIONTYPE: 'destinationtype',
  GETDESTINATIONTYPEBYID: "destinationtype/getbyid",
  DELETEDESTIONTYPE: 'destinationtype',
  

  GETALLDESTINATIONS: 'destination/getall',
  GETDESTINATION: 'destination/get',
  GETDESTINATIONBYID: 'destination/getbyid',
  GETALLDESTINATIONBYCOMPNAYID: 'destination/getallbycompany',
  GETDESTINATIONBYCOMAPANYID: 'destination/getbycompany',
  CREATEDESTINATION: 'destination',
  UPDATEDESTINATION: 'destination',
  DELETEDESTINATION: 'destination',
  GETDESTINATIONSEARCH: 'destination/search',


  GETALLTRAVELTYPES: 'traveltype/getall',
  GETTRAVELTYPE: 'traveltype',
  CREATETRAVELTYPE: 'traveltype',
  UPDATETRAVELTYPE: 'traveltype',
  GETTRAVELTYPEBYID: 'traveltype/getbyid',
  DELETETRAVELTYPE: 'traveltype',

  GETALLPACKAGES: 'package/getall',
  GETPACKAGE: 'package/get',
  GETPACKAGEBYID: 'package/getbyid',
  GETPACKAGEBYCOMAPANYID: 'package/getbycompany',
  CREATEPACKAGE: 'package',
  UPDATEPACKAGE: 'package',
  DELETEPACKAGE: 'package',
  GETPACKAGEDETAILS: 'package/getpackagedetails',
  CLONEPACKAGE: 'package/clone',
  GETPACKAGESBYDESTINATION: 'package/getbydestination',
  GETPACKAGESBYSEARCH: 'package/getbysearch',
  GETPACKAGESBYUMRAHSEARCH: 'package/getbysearchumrah',
  GETPACKAGEBYTRAVELTYPE: 'package/getbytraveltype',
  GETPACKAGESBYHAJJSEARCH: 'package/getbysearchhajj',


  GETALLPACKAGEFLIGHT: 'pacakgeflightbooking/getall',
  GETPACKAGEFLIGHT: 'packageflightbooking/get',
  GETPACKAGEFLIGHTBYID: 'pacakgeflightbooking/getbyid',
  GETFLIGHTBYPACKAGEID: 'packageflightbooking/getflightbypackageid',
  CREATEPACKAGEFLIGHT: 'packageflightbooking',
  UPDATEPACKAGEFLIGHT: 'packageflightbooking',
  DELETEPACKAGEFLIGHT: 'packageflightbooking',


  GETALLPACKAGEHOTEL: 'pacakgebooking/getall',
  GETPACKAGEHOTEL: 'packagehotelbooking/get',
  GETPACKAGEHOTELBYID: 'pacakgehotelbooking/getbyid',
  GETHOTELBYPACKAGEID: 'packagehotelbooking/gethotelbypackageid',
  CREATEPACKAGEHOTEL: 'packagehotelbooking',
  UPDATEPACKAGEHOTEL: 'packagehotelbooking',
  DELETEPACKAGEHOTEL: 'packagehotelbooking',

  GETALLPACKAGESIGHT: 'pacakgesightseeing/getall',
  GETPACKAGESIGHT: 'packagesightseeing/get',
  GETPACKAGESIGHTBYID: 'pacakgesightseeing/getbyid',
  GETSIGHTBYPACKAGEID: 'packagesightseeing/getsightseeingbypackageid',
  CREATEPACKAGESIGHT: 'packagesightseeing',
  UPDATEPACKAGESIGHT: 'packagesightseeing',
  DELETEPACKAGESIGHT: 'packagesightseeing',


  GETALLPACKAGEINCLUDES: "packageinclude/getall",
  GETPACKAGEINCLUDE: "packageinclude/get",
  GETALLPACKAGEINCLUDEBYID: "packageinclude/getbyid",
  GETINCLUDEBYPACKAGEID: "packageinclude/getincludebypackageid",
  CREATEPACKAGEINCLUDE: "packageinclude",
  UPDATEPACKAGEINCLUDE: "packageinclude",
  DELETEPACKAGEINCLUDE: "packageinclude",

  GETALLPACKAGEEXCLUDES: "packageexclude/getall",
  GETPACKAGEEXCLUDE: "packageexclude/get",
  GETALLPACKAGEEXCLUDEBYID: "packageexclude/getbyid",
  GETEXCLUDEBYPACKAGEID: "packageexclude/getexcludebypackageid",
  CREATEPACKAGEEXCLUDE: "packageexclude",
  UPDATEPACKAGEEXCLUDE: "packageexclude",
  DELETEPACKAGEEXCLUDE: "packageexclude",

  GETALLTERMS: "packagetermsandcondition/getall",
  GETPACKAGETERMS: "packagetermsandcondition/get",
  GETALLPACKAGETERMSBYID: "packagetermsandcondition/getbyid",
  GETTERMSBYPACKAGEID: "packagetermsandcondition/gettermsbypackageid",
  CREATEPACKAGETERMS: "packagetermsandcondition",
  UPDATEPACKAGETERMS: "packagetermsandcondition",
  DELETEPACKAGETERMS: "packagetermsandcondition",

  GETALLTRANSFERS: "pacakgetransfer/getall",
  GETPACKAGETRANSFER: "pacakgetransfer/get",
  GETALLPACKAGETRANSFERBYID: "pacakgetransfer/getbyid",
  GETTRANSFERBYPACKAGEID: "pacakgetransfer/gettransferbypackageid",
  CREATEPACKAGETRANSFER: "pacakgetransfer",
  UPDATEPACKAGETRANSFER: "pacakgetransfer",
  DELETEPACKAGETRANSFER: "pacakgetransfer",

  GETALLITINERAIES: "packageitinerary/getall",
  GETPACKAGEITINERARY: "packageitinerary/get",
  GETALLPACKAGEITINERARYBYID: "packageitinerary/getbyid",
  GETITINERARYBYPACKAGEID: "packageitinerary/getitinerarybypackageid",
  CREATEPACKAGEITINERARY: "packageitinerary",
  UPDATEPACKAGEITINERARY: "packageitinerary",
  DELETEPACKAGEITINERARY: "packageitinerary",


  GETALLCUSTOMERS: 'customer/getall',
  GETCUSTOMERS: 'customer/get',
  GETCUSTOMERBYID: 'customer/getbyid',
  GETCUSTOMERBYCOMAPANYID: 'customer/getbycompany',
  CREATECUSTOMER: 'customer',
  UPDATECUSTOMER: 'customer',
  DELETECUSTOMER: 'customer',
  GETALLCUSTOMERSBYCOMPANYID: "customer/getallbycompanyid",

  MARKETING: 'marketing/sendcampaign',

  SIGHTSEEINGPRODUCTS: 'sightseeing/getproducts',
  SIGHTSEEINGPRODUCT: 'sightseeing/getproduct',
  SIGHTSEEINGBOOK: "sightseeing/book",
  GETSIGHTSEEINGBOOKINGDETAILS: "sightseeing/getbyid",
  GETUSERSIGHTSEEINGBOOKINGS: 'sightseeing/getbyuser',

  SEARCHHOTEL: 'hotel/search',
  GETHOTELROOMS: 'hotel/rooms',
  HOTELREVIEW: 'hotel/review',
  B2CBOOKHOTEL: 'hotel/b2cbook',
  GETUSERHOTELBOOKINGS: 'hotel/getbyuser',
  GETHOTELBOOKINGDETAILS: 'hotel/getbyid',
  GETHOTELNAMES:'Hotel/autocomplete',
  GETHOTELCITIES:'home/hotel-city/autocomplete',

  GETALLORIGIN: 'fromorigin/getall',
  GETORIGIN: 'fromorigin/get',
  GETORIGINBYID: 'fromorigin/getbyid',
  GETALLORIGINBYCOMPANYID: 'fromorigin/getallbycompany',
  GETORIGINBYCOMPANYID: 'fromorigin/getbycompany',
  CREATEORIGIN: 'fromorigin',
  UPDATEORIGIN: 'fromorigin',
  DELETEORIGIN: 'fromorigin', 
  GETORIGINSEARCH: 'fromorigin/search',

  GETALLPACKAGEDATE: 'packagedate/getall',
  GETPACKAGEDATE: 'packagedate/get',
  GETPACKAGEDATEBYID: 'packagedate/getbyid',
  GETALLPACKAGEDATEBYCOMPANY: 'packagedate/getallbycompany',
  GETPACKAGEDATEBYCOMPANYID: 'packagedate/getbycompany',
  CREATEPACKAGEDATE: 'packagedate',
  UPDATEPACKAGEDATE: 'packagedate',
  DELETEPACKAGEDATE: 'packagedate',
 
  GETALLPACKAGEENQUIRY: 'packageenquiry/getall',
  GETPACKAGEENQUIRYBYID: 'packageenquiry/getbyid',
  GETPACKAGEENQUIRYBYCOMPANYID: 'packageenquiry/getbycompany',
  CREATEPACKAGEENQUIRY: 'packageenquiry',
  UPDATEPACKAGEENQUIRY: 'packageenquiry',
  DELETEPACKAGEENQUIRY: 'packageenquiry',

  GETLANDINGBYCOMPANY: "landingpage/getbyCompany",
  UPDATELANDINGPAGE: "landingpage",

  SEARCHFBUSES: "bus/search",
  GETBUSSEATS: "bus/seats",
  GETBUSBOOKINGBYID: "bus/getbooking",
  BOOKBUSSEATS: "bus/b2cbookbusticket",
  CONFIRMBUSBOOKING: "/bus/confirmbooking",
  GETBUSBOOKINGS: "bus/getbookings",
  GETUSERBUSBOOKINGS: "bus/getbyuser",

  GETCOMPANYTEMPLATEBYTENANT: "template/by-tenant",
  GETCOMPANYB2CTEMPLATEBYTENANT: "template/b2c-by-tenant",
  GETTEMPLATEBYDOMAIN: "template/by-domain",
     
  ASSIGNTEMPLATE: "template/assign-to-company",

 GETMARKUPBYCOMPANYID: "companymarkup/getallmarkupsbycompany",
  
  GETCOUNTRIES:"VisaMaster/countries",
  GETHOMEPAGEVISAS: "visamaster/homepage/visas",
  GETHOMEPAGECOUNTRIES: "visamaster/homepage/countries",
  GETB2CDISPLAYVISAS: 'clientvisaprice/getb2cdisplayvisas',
  GETHOMEVISAS: 'visamaster/home',// this has remove dont use 
  GETVISADETAILSPRICE: 'visamaster/visa-details-with-pricing',// this has remove dont use 

  GETDMCPACKAGESBYCOMPANYID: 'dmc/packages/by-company', 
   GETDMCPACKAGEBYID: 'dmc/packages',
   GETSIGHTSEEINGDEALS:"companysightseeing/getall",

   GETCOMPANYPACKAGESBYCOMPANY: "companyPackages/company",
   GETCOMPANYPACKAGEBYID: "companyPackages",
   GETALLMASTERPACKAGES: "masterpackage/all",
   GETMASTERPACKAGEBYID: "masterpackage",



   GETCOMPANYSIGHTSEEINGBYCOMPANYID: "companysightseeing/getbycompany",
   SIGHTSEEINGMASTERSEARCH:"sightseeing/search",

    GETCURRENTPROMOCODES: 'promocode/activepromocodes',
    VERIFYPROMOCODE: 'promoCode/verifypromocode'

}